export enum CancelReasonType {
  LaidOff = 1,
  FinancialRestrictions = 2,
  DonorNotConfident = 3,
  DonorNoInterested = 4,
  DidNotWantToDisclose = 5,
  Other = 6,
  UnsureHowUsed = 7
}
